<template>
  <div>
    <div class="sidebar-cnt" :class="{ hide: menuHide }">
      <v-icon class="icon-menu" :class="{ hide: menuHide }" @click="hideMenu()"
        >sort</v-icon
      >
      <div class="side-menu" :class="{ hide: menuHide }">
        <ul id="main-menu">
          <li class="active" id="influence" @click="anchorNav('influence')">
            {{ $t("views.diagnostics.influence") }}
          </li>
          <ul>
            <li
              id="poblationchart"
              @click="anchorNav('poblation', 'poblationchart')"
            >
              {{ $t("views.diagnostics.poblationchart") }}
            </li>
            <li
              id="poblationoptions"
              @click="anchorNav('poblation', 'poblationoptions')"
            >
              {{ $t("views.diagnostics.poblationoptions") }}
            </li>
            <li id="clients" @click="anchorNav('clients')">
              {{ $t("views.diagnostics.clients") }}
            </li>
            <li id="competence" @click="anchorNav('competence')">
              {{ $t("views.diagnostics.competence") }}
            </li>
          </ul>
          <li id="sales" @click="anchorNav('sales')">
            {{ $t("views.diagnostics.sales") }}
          </li>
          <ul>
            <li id="moments" @click="anchorNav('moments')">
              {{ $t("views.diagnostics.moments") }}
            </li>
            <li id="pmix" @click="anchorNav('pmix')">
              {{ $t("views.diagnostics.pmix") }}
            </li>
            <!-- <li id="consum" @click="anchorNav('consum')">Segmentos de consumo</li> -->
          </ul>
          <li id="dafo" @click="anchorNav('dafo')">
            {{ $t("views.diagnostics.dafo") }}
          </li>
        </ul>
        <span class="side-info"><b>*</b> {{ $t("views.diagnostics.side_info") }}</span>
      </div>
      <div class="print" :class="{ hide: menuHide }" @click="printPage()">
        <span v-if="!menuHide">{{ $t("general.export_report") }}</span>
      </div>
    </div>

    <div class="content" :class="{ hide: menuHide }">
      <div ref="influence">
        <div class="location-info">
          {{ $t("views.diagnostics.location_info") }}<span class="location-data"
            >{{ selectedLocation.site }} {{ selectedLocation.name }}</span
          >
        </div>
        <div class="title area">{{ $t("views.diagnostics.influence") }}</div>

        <div class="poblation part">
          <Poblation ref="poblation" :size="size"></Poblation>
        </div>

        <div class="clients part" ref="clients">
          <Clusters ref="clusters"></Clusters>
        </div>

        <div class="competence part" ref="competence">
          <Competence ref="competencecomponent"></Competence>
        </div>
      </div>

      <div class="sales" ref="sales">
        <div class="title area">{{ $t("views.diagnostics.sales") }}</div>

        <div class="moments part" ref="moments">
          <div class="title">{{ $t("views.diagnostics.moments") }}</div>
          <Moments></Moments>
        </div>

        <div class="pmix part" ref="pmix">
          <div class="title">{{ $t("views.diagnostics.pmix") }}</div>
          <Pmix></Pmix>
        </div>

        <!-- <div class="consum part" ref="consum">
            <div class="title">Segmentos de consumo</div>
            <Consume ref="consume" :size="size"></Consume>
          </div> -->
      </div>

      <div class="dafo part" ref="dafo">
        <div class="title area">{{ $t("views.diagnostics.dafo") }}</div>
        <DAFO ref="dafocomponent"></DAFO>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from "@/i18n";
import DAFO from "@/components/domain/diagnostic/DAFO";
import Poblation from "@/components/domain/diagnostic/Poblation";
import Clusters from "@/components/domain/diagnostic/Clusters";
import Competence from "@/components/domain/diagnostic/Competence";
import Consume from "@/components/domain/diagnostic/Consume";
import Moments from "@/components/domain/diagnostic/Moments";
import Pmix from "@/components/domain/diagnostic/Pmix";

export default {
  name: "Diagnostic",
  components: { DAFO, Poblation, Clusters, Competence, Consume, Moments, Pmix },
  data() {
    return {
      menuHide: false,
      scrolling: false,
      scrollWait: false,
      size: "100%"
    };
  },
  computed: {
    selectedLocation() {
      return this.$store.getters["locations/getSelectedLocation"];
    }
  },
  methods: {
    printPage: function() {
      this.size = "600";
      this.$overlay.loading();
      var self = this;
      setTimeout(function() {
        self.$overlay.hide();
        self.size = "100%";
        window.print();
      }, 1500);
    },

    hideMenu: function() {
      this.menuHide = !this.menuHide;
    },

    anchorNav: function(refName, refChild) {
      if (!refChild) {
        var element = this.$refs[refName];
      } else {
        var element = this.$refs[refName].$refs[refChild];
      }

      var top = element.offsetTop;
      window.scrollTo(0, top - 80);
      this.handleScroll();
    },

    getScroll() {
      if (!this.menuHide) {
        if (this.scrollWait) {
          this.scrollWait = true;
        }
        window.clearTimeout(this.scrolling);

        var self = this;

        this.scrolling = setTimeout(function() {
          self.handleScroll();
          self.scrollWait = false;
        }, 500);
      }
    },

    handleScroll() {
      if (document.getElementsByClassName("active").length > 0) {
        var active = document.getElementsByClassName("active");
        active[0].className = "";
      }
      var element;
      var exitfor = false;
      for (var index in this.$refs) {
        if (index == "poblation") {
          for (var child in this.$refs.poblation.$refs) {
            if (
              window.scrollY + 90 >= this.$refs[index].$refs[child].offsetTop &&
              window.scrollY + 90 <=
                this.$refs[index].$refs[child].offsetTop +
                  this.$refs[index].$refs[child].offsetHeight
            ) {
              element = child;
              exitfor = true;
              break;
            }
          }
          if (exitfor) {
            break;
          }
        } else if (
          window.scrollY + 90 >= this.$refs[index].offsetTop &&
          window.scrollY + 90 <=
            this.$refs[index].offsetTop + this.$refs[index].offsetHeight
        ) {
          element = index;
          break;
        }
      }
      document.getElementById(element).className = "active";
    }
  },
  watch: {},
  created() {
    this.$store.commit("setTitle", this.$t("views.diagnostics.name"));
    this.$store.commit("setMenuVisible", false);

    this.$store.dispatch("locations/loadDiagnosticDescriptions", {});

    window.addEventListener("scroll", this.getScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.getScroll);
  },
  beforeRouteLeave(to, from, next) {
    if (
      this.$refs.clusters.checkChangesBeforeExit() &&
      this.$refs.competencecomponent.checkChangesBeforeExit() &&
      this.$refs.dafocomponent.checkChangesBeforeExit()
    ) {
      next();
    } else {
      var self = this;
      this.$popup.confirm(
        this.$t("views.diagnostics.popup.leave_title"),
        this.$t("views.diagnostics.popup.leave_message"),
        this.$t("general.leave_confirm"),
        this.$t("general.leave_cancel"),
        function() {
          next();
        }
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@media print {
  .content {
    margin-top: 10px !important;
  }
}

/* SIDEBAR */
.sidebar-cnt {
  position: fixed;
  left: 30px;
  padding-top: 20px;
  padding-bottom: 20px;
  width: 250px;
  height: 80%;

  i {
    color: var(--secondary_color);
  }

  &.hide {
    width: 50px;
  }

  .icon-menu {
    float: left;
    cursor: pointer;

    &.hide {
      transform: rotate(180deg);
    }
  }

  .side-menu {
    width: 250px;
    display: inline-block;
    float: left;
    padding-bottom: 20px;
    height: 95%;
    margin-top: 20px;

    &.hide {
      visibility: hidden;
    }

    #main-menu {
      text-align: left;
      padding: 0;
      border-right: 2px solid var(--secondary_color);

      li {
        cursor: pointer;
        font-size: 18px;
        margin-top: 15px;
        list-style: none;
        width: fit-content;

        &.active {
          color: var(--secondary_color);
          font-weight: bold;
        }
      }

      ul {
        margin: 0 0 0 2em;

        li {
          font-size: 16px;
          margin-top: 5px;
          list-style: circle;
        }
      }
    }

    .side-info {
      margin-top: 50px;
      float: left;
      color: #999;
      font-size: 14px;
    }
  }

  .print {
    float: left;
    padding: 10px 20px;
    background-color: var(--secondary_color);
    background: url("/img/export.svg") no-repeat left 5px center;
    background-size: 20px;
    padding-left: 40px;

    color: #555;
    border-radius: 30px;
    font-size: 16px;
    cursor: pointer;

    &.hide {
      background-color: transparent;
      padding: 0px;
      background-image: url("/img/export_sel.svg");
      width: 50px;
      height: 50px;

      i {
        color: var(--secondary_color);
      }
    }
  }
}

/* CONTENT */
.content {
  width: calc(100% - 250px);
  display: inline-block;
  float: right;
  padding: 20px 40px;

  &.hide {
    width: calc(100%);
    transition: 0.2s;
  }

  .print-only {
    display: none;
  }

  .location-info {
    font-size: 15px;
    border-bottom: 1px solid #ddd;
    width: 100%;
    padding: 5px 20px;
    margin: 0 auto;
    margin-bottom: 20px;
    text-align: right;
    color: #bbb;

    .location-data {
      font-size: 17px;
      font-weight: bold;
      margin-left: 10px;
    }
  }

  div {
    padding-bottom: 20px;
    overflow: auto;
  }

  .title {
    width: auto;

    &.area {
      padding: 30px 0px;
      width: auto;
      font-size: 20px !important;
      background-color: black;
      color: white;
      margin: 35px 0;
      background-color: #eee;
      -webkit-print-color-adjust: exact;
      color: #999;
      margin-bottom: 20px;
      text-transform: uppercase;
    }

    &.subarea {
      background: var(--main_color);
      color: var(--dark_color);
      display: inline-block;
      text-align: center;
      font-size: 19px;
      font-family: Speedee-Bold;
      margin: 0;
      margin-top: 5px;
      padding: 5px 10px;
      margin-bottom: 10px;
      z-index: 1;
      margin-bottom: 10px;
    }
  }

  .header {
    width: 100%;
    text-align: left;
    margin-bottom: 15px;
    overflow: hidden;

    .meta {
      float: left;
      width: 70%;

      .breadcrumbs {
        color: #aaa;
        display: block;
        width: 100%;
      }
    }

    .filter {
      float: left;
      width: 30%;
      text-align: right;
      padding: 0 10px;

      .search {
        display: block;
        overflow: hidden;
        margin-top: 5px;
        -webkit-transition: all 1s;
        transition: all 1s;

        .input {
          border: none;
          border-bottom: 2px solid #ccc;
          padding: 5px;
          outline: none;
          background: url("/img/magnify.svg") no-repeat right 5px center;
          background-size: 20px;
          width: 100%;
          float: left;
        }
        .icon {
          display: none;
          cursor: pointer;
          width: 30px;
          height: 30px;
          background: url("/img/go.svg") no-repeat center var(--main_color);
          background-size: 20px;
          border-radius: 3px;
        }

        &.active {
          .input {
            width: calc(100% - 40px);
            background: transparent;
          }
          .icon {
            display: inline-block;
          }
        }
      }
    }
  }

  .table {
    margin-bottom: 10px;
    max-width: 100%;
  }

  .part {
    overflow: auto;
  }

  .poblation {
    .title {
      margin-bottom: 0px;
    }
  }

  .dafo {
    min-height: 100vh;
  }
}
</style>

<style lang="scss">
@page {
  margin: 0mm !important;

  body {
    margin: 0mm !important;
  }

  body {
    /*transform: scale(.7);*/
  }
  /*table {
    page-break-inside: avoid;
    height: 50%;
  }*/

  size: A4;
}

@media print {
  @page {
    size: A4;
  }

  #app {
    width: 100% !important;
  }

  html,
  body {
    width: 100% !important;
    margin: 0;
    background-color: #fff !important;
  }
  body {
    width: 95% !important;
    margin: 20px 2.5%;
  }

  .overlay {
    display: none !important;
  }

  #container {
    width: 100% !important;
    margin-top: -20px !important;
  }
  .print-only {
    display: block !important;
  }

  #header,
  #footer {
    display: none !important;
  }
  .separator {
    /*height: 0 !important;*/
  }

  table {
    max-width: 100vw !important;
  }

  #app {
    background-color: white !important;
    margin-top: -60px !important;
  }

  .sidebar-cnt {
    display: none !important;
  }

  .content {
    width: 100% !important;
    padding: 0px !important;
    margin: 0px 0px !important;
  }

  .no-print,
  .no-print * {
    display: none !important;
  }

  .poblation.char {
    max-width: 100% !important;
    overflow: hidden !important;
    width: 100% !important;
    margin-top: 0 !important;
  }

  .canvas {
    /*max-width: 100% !important;
        overflow: hidden !important;
        width: 100% !important;
        text-align: center;
        margin-top: -60px !important;
        margin-bottom: 0px !important;*/

    min-height: 100%;
    max-width: 100%;
    max-height: 100%;
    height: auto !important;
    width: auto !important;

    .apexcharts-canvas {
      max-width: 100% !important;
      width: 100% !important;
      transform: scale(0.9);
      margin: 0 auto;
    }
  }

  .poblation.options {
    width: 100% !important;
    float: none !important;
    overflow: hidden !important;

    .sec-description {
      margin-bottom: 15px !important;
    }

    .option {
      display: none !important;
      padding: 2px 7px !important;

      &.checked {
        display: inline-block !important;
      }
    }
  }

  .legend {
    display: none !important;
  }

  .week {
    /*page-break-inside: avoid !important;
      page-break-before: always !important;*/
  }

  .clients {
    page-break-inside: avoid !important;
    page-break-before: always !important;
  }

  .competence {
    page-break-inside: avoid !important;
    page-break-before: always !important;

    .subarea {
      page-break-inside: avoid !important;
      page-break-before: always !important;
    }

    .brand {
      font-size: 12px !important;
      background-color: transparent !important;
    }

    .comparation {
      /*transform: rotate(-90deg) !important;
        position: absolute !important;*/
      /*page-break-inside: avoid;
        height: 50%;*/

      .tooltip {
        width: 70px !important;
      }
      .tooltiptext {
        width: 70px !important;
      }

      .tooltiptext > label {
        width: 14px !important;
        font-size: 20px !important;
      }

      select {
        padding: 0 !important;
        width: 125px !important;
        border: none !important;
        -webkit-appearance: none !important;
        text-align: center;
      }
    }
  }

  .sales {
    page-break-inside: avoid !important;
    page-break-before: always !important;
  }

  .pmix {
    page-break-inside: avoid !important;
    page-break-before: always !important;
  }
  .consum {
    page-break-inside: avoid !important;
    page-break-before: always !important;
  }

  .sec-description {
    font-size: 12px !important;
  }

  .dafo {
    page-break-inside: avoid !important;
    page-break-before: always !important;
    min-height: initial !important;

    .description {
      display: none !important;
    }
    .more {
      display: none !important;
    }

    .dafo-table {
      .text {
        font-size: 14px !important;

        textarea {
          padding-bottom: 40px;
          height: fit-content;
        }
      }
    }
  }
}
</style>
